// Premium DCC palette tokens — single source of truth for any page that
// needs the navy/gold colors directly in `sx={{ ... }}` without redefining.
//
// Import like:
//   import { NAVY, GOLD, BORDER } from '../../theme/tokens';

export const NAVY = "#0B1E2D";
export const NAVY_DARK = "#071521";
export const GOLD = "#058dd0";
export const GOLD_SOFT = "#3aa9e0";

export const PAGE_BG = "#F8FAFC";
export const CARD_BG = "#FFFFFF";

export const TEXT_PRIMARY = "#1F2937";
export const TEXT_SECONDARY = "#6B7280";

export const BORDER = "#E5E7EB";

export const SUCCESS = "#16A34A";
export const ERROR = "#EF4444";
export const WARNING = "#EA580C";
export const INFO = "#3B82F6";

// Common gradient string for the navy sidebar / brand tiles.
export const NAVY_GRADIENT = `linear-gradient(180deg, ${NAVY} 0%, ${NAVY_DARK} 100%)`;

// Common gold CTA gradient.
export const GOLD_GRADIENT = `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_SOFT} 100%)`;

// Soft gold ring for "premium" focus / hover states.
export const GOLD_GLOW = "0 0 0 2px rgba(5,141,208,0.2)";
